import "@stimulus/polyfills";
import "core-js/es/array/for-each";
import "core-js/es/array/includes";
import "core-js/es/string/starts-with";
import "core-js/es/string/virtual/includes";
import "formdata-polyfill";
import "@webcomponents/template";
window.NodeList && !NodeList.prototype.forEach && (NodeList.prototype.forEach = Array.prototype.forEach), function () {
  if ("function" == typeof window.CustomEvent) return !1;

  window.CustomEvent = function (t, o) {
    o = o || {
      bubbles: !1,
      cancelable: !1,
      detail: null
    };
    var e = document.createEvent("CustomEvent");
    return e.initCustomEvent(t, o.bubbles, o.cancelable, o.detail), e;
  };
}();